module.exports = __webpack_public_path__ + "assets/img/8.62c0efac.jpg";